/* ==========================================================================
   Enwrape - Buy now, on both bars

   The theme has TWO bottom bars and swaps them at 768px:

     #sticky-atc-bar        class .desk-only-sticky
                            base.css: @media(max-width:768px){ .desk-only-sticky{display:none} }
                            -> desktop only. Image, title, price, quantity, Add to cart.

     .product-bottom-buttons
                            base.css: display:none, then inside
                            @media(max-width:768px) it becomes
                            position:fixed; bottom:0; width:100%; display:block
                            -> mobile only. Renders snippets/buy-buttons a SECOND
                               time, which is also where the duplicated product
                               form comes from.

   Neither bar had a Buy now. On mobile the row carries Shopify's dynamic
   checkout button in markup, but Shopify hydrates only the first
   payment_button on a page and that one is higher up the page, so the mobile
   row rendered Add to cart and an empty gap - which is exactly what the
   screenshot shows.

   So: one Buy now per bar, built here, each submitting the form it sits in.

   Also fixes the reveal of the desktop bar. stickyAtc() in enwrape-custom.js
   drives it from an IntersectionObserver on the main Add to cart, which sits
   inside .product__info-container - position:sticky, because enable_sticky_info
   is on. A fresh observer on that element produced ZERO callbacks across a
   full scroll, so .hidden was never removed. A plain scroll handler replaces
   it; the work is one getBoundingClientRect and a classList.toggle.
   ========================================================================== */
(function () {
  'use strict';

  function syncVariants() {
    if (typeof window.enwrapeSyncVariants === 'function') {
      try { window.enwrapeSyncVariants(); } catch (e) {}
    }
  }

  /* Build a Buy now that adds this form's item, then goes to checkout. */
  function makeBuyButton(form, mirrorBtn, qtyInput) {
    var buy = document.createElement('button');
    buy.type = 'button';
    buy.className = 'ew-sticky-buy';
    buy.textContent = 'Buy now';

    function syncDisabled() {
      buy.disabled = mirrorBtn.disabled || mirrorBtn.hasAttribute('disabled');
    }
    syncDisabled();
    try {
      new MutationObserver(syncDisabled).observe(mirrorBtn, {
        attributes: true,
        attributeFilter: ['disabled']
      });
    } catch (e) {}

    buy.addEventListener('click', function () {
      if (buy.disabled || !form) return;

      if (qtyInput) {
        var mainQty =
          document.querySelector('product-info input[name="quantity"]') ||
          document.querySelector('input[name="quantity"]');
        if (mainQty) mainQty.value = qtyInput.value || '1';
      }

      syncVariants();

      buy.disabled = true;
      buy.textContent = 'One moment';

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        })
        .catch(function () {
          buy.disabled = false;
          buy.textContent = 'Buy now';
          mirrorBtn.click();
        });
    });

    return buy;
  }

  function init() {
    var mainBtn =
      document.querySelector('product-info button[name="add"]') ||
      document.querySelector('button[name="add"]');
    if (!mainBtn) return;

    /* ---------------------------------------------------------------
       Desktop bar: reveal on scroll, then add Buy now.
       --------------------------------------------------------------- */
    var bar = document.getElementById('sticky-atc-bar');
    if (bar && !bar.contains(mainBtn)) {
      var update = function () {
        try {
          var r = mainBtn.getBoundingClientRect();
          var gone = r.bottom < 0;
          var docH = Math.max(
            document.body.scrollHeight,
            document.documentElement.scrollHeight
          );
          var atFoot = window.innerHeight + window.pageYOffset >= docH - 200;
          var shouldHide = !gone || atFoot;
          if (bar.classList.contains('hidden') !== shouldHide) {
            bar.classList.toggle('hidden', shouldHide);
          }
        } catch (e) {}
      };

      document.addEventListener('scroll', update, { passive: true, capture: true });
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      window.addEventListener('load', update);
      window.addEventListener('pageshow', update);
      setInterval(update, 500);
      update();

      var action =
        bar.querySelector('.sticky-atc-action') ||
        bar.querySelector('.sticky-atc-inner');
      var stickyBtn = document.getElementById('sticky-atc-btn');
      if (action && stickyBtn && !action.querySelector('.ew-sticky-buy')) {
        var deskForm =
          mainBtn.form ||
          document.querySelector('product-info form[action*="/cart/add"]') ||
          document.querySelector('form[action*="/cart/add"]');
        action.appendChild(
          makeBuyButton(deskForm, stickyBtn, document.getElementById('sticky-qty'))
        );
      }
    }

    /* ---------------------------------------------------------------
       Mobile bar: add Buy now beside its own Add to cart.
       --------------------------------------------------------------- */
    var mob = document.querySelector('.product-bottom-buttons');
    if (!mob) return;

    var mobBtn = mob.querySelector('button[name="add"], .product-form__submit');
    if (!mobBtn) return;

    var row =
      mob.querySelector('.cus-product-form__buttons') ||
      mob.querySelector('.product-form__buttons') ||
      mobBtn.parentElement;
    if (!row || row.querySelector('.ew-sticky-buy')) return;

    row.appendChild(makeBuyButton(mobBtn.form, mobBtn, null));
    row.classList.add('ew-has-buy');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
